<template>
    <div class="p-2" v-if="currentEdit == null">
        <b-row>
            <b-col cols="12" offset-md="10" md="2"><b-button @click="create" variant="success" block> {{ $t('create') }} </b-button></b-col>
            <b-col cols="12" md="3" v-for="(func, idx) in content" :key="idx" style="cursor: pointer;" @click="edit(func)">
                <b-card>
                    {{ func.name }}
                </b-card>
            </b-col>
        </b-row>
    </div>

    <div v-else>
        <b-icon icon="arrow-left" @click="currentEdit = null" class="mb-2"/>

        <protokol-invalid-feedback :errors="validator.fieldErrors('name')">
            <b-form-input v-model="currentEdit.name" :placeholder="$t('name')" class="mb-2" :disabled="currentEdit.mode == 'edit'"></b-form-input>
        </protokol-invalid-feedback>

        <CodeEditor v-model="currentEdit.expr" :options="{mode: 'javascript'}" :withButton="false"></CodeEditor>
        <b-button @click="save" variant="success"> {{ $t('save') }}</b-button>
        <b-button @click="remove" class="ml-2" variant="danger" v-if="currentEdit.mode == 'edit'"> {{ $t('remove') }}</b-button>
        <b-button @click="testSidebar = true" class="ml-2" variant="warning" v-if="currentEdit.mode == 'edit'"> {{ $t('test') }}</b-button>

        <CodeEditor :value="testOutput" :options="{mode: 'json'}" :withButton="false" v-if="testOutput" class="mt-4"></CodeEditor>

        <b-sidebar right v-model="testSidebar">
            <div class="p-2">
                <CodeEditor v-model="testInput" :options="{mode: 'json'}" :withButton="false"></CodeEditor>
                <b-button @click="test" variant="success"> {{ $t('test') }}</b-button>
            </div>
        </b-sidebar>
    </div>
</template>

<script>
import CodeEditor from '@/components/form/Editor/Code'

export default {
    components: {
        CodeEditor
    },
    props: {
        id: {
            type: String
        },

        value: {
            type: Array,
            default: () => []
        },

        config: {
            type: Object,
            default: () => {}
        }
    },

    data: function() {
        return {
            currentEdit: null,
            createSidebar: false,
            testOutput: null,
            testInput: null,
            testSidebar: false,
            validator: this.$validator()
        }
    },

    computed: {
        content: {
            get() {
                return this.value || []
            },

            set(val) {
                this.$emit('input', val)
            }
        }
    },

    methods: {
        create() {
            this.currentEdit = {
                mode: 'create',
                name: '',
                expr: ''
            }

            this.validate()
            
        },

        save() {
            this.validator.revalidate()

            if (!this.validator.pass()) {
                return
            }

            if (this.currentEdit.mode == 'create') {
                const exist = this.content.find(f => f.name == this.currentEdit.name)
                if (exist) {
                    this.$bvToast.toast(this.$t('functionExists'), {
                        title: 'Error',
                        variant: 'danger',
                        autoHideDelay: 5000
                    })

                    return
                }

                this.content.push(this.currentEdit)
                this.currentEdit = null

            } else if (this.currentEdit.mode == 'edit') {
                const idx = this.content.findIndex(f => f.name == this.currentEdit.name)
            
                this.$set(this.content, idx, {
                    name: this.currentEdit.name,
                    expr: this.currentEdit.expr
                })

                this.currentEdit = null
            }

            this.$emit('input', this.content)
        },

        async test() {
            if (this.testInput == "") {
                this.testInput = null
            }
            
            const resp = await this.$http.post(`/v3/system/component/${this.id}/function/${this.currentEdit.name}`, {
                data: JSON.parse(this.testInput),
                options: {
                    expression: this.currentEdit.expr,
                    config: this.config
                }
            })
            this.testOutput = JSON.stringify(resp.data, null, 4)
        },

        edit(f) {
            this.currentEdit = {
                mode: 'edit',
                name: f.name,
                expr: f.expr
            }

            this.validate()
        },

        async remove() {
            const confirm = await this.$bvModal.msgBoxConfirm(this.$t('areYouSure') + "?", {
                title: this.$t('confirm'),
                size: 'sm',
                okVariant: 'danger',
                okTitle: this.$t('yes'),
                cancelTitle: this.$t('no'),
                footerClass: 'p-2'
            })

            if (!confirm) return

            const idx = this.content.findIndex(f => f.name == this.currentEdit.name)
            this.content.splice(idx, 1)
            this.currentEdit = null
        },

        validate() {
            this.validator.validate(this.currentEdit, {
                default: (model, errors) => {
                    if (!model.name) errors.add('name', [this.$t('fieldRequired')])
                }
            })
        }
    }
}
</script>